<template>
    <div class="app-footer  text-center" >
       <a>Copyright © 2019 - 2021 长会教育</a>
    </div>
</template>
<script>
	export default {
		name: "AppFooter"
	};
</script>
<style lang="less">
	.app-footer {
		text-align: center;
        padding-bottom: 15px!important;
		color: rgba(0, 0, 0, .45);

		a {
			color: rgba(0, 0, 0, .45);
		}
	}
</style>
